import moment from 'moment'
import { find, template, cloneDeep, isEmpty } from 'lodash'
import { airlines } from '../../utils/from'

export const MINIO_FRONTEND_STATIC_ROUTE = '/frontend.static'

const getBirthDay = (idCard) => {
  let birth = ''
  if (idCard.length === 15) {
    birth = idCard.slice(6, 12)
    birth = '19' + birth
  } else if (idCard.length === 18) {
    birth = idCard.slice(6, 14)
  }
  const birthday = birth.slice(0, 4) + '-' + birth.slice(4, 6) + '-' + birth.slice(6, 8)
  const birthFormat = moment(birthday, 'YYYY-MM-DD')
  return { birthFormat, birthday }
}

const isOverSixteen = (idCard, departureDate) => {
  if (!idCard || !departureDate) return false
  const birthFormat = getBirthDay(idCard).birthFormat
  const flightFormat = moment(departureDate, 'YYYY-MM-DD')
  const diffYears = flightFormat.diff(birthFormat, 'years')
  return !(diffYears >= 16)
}

const isYoungOrOld = (idCard, departureDate, ageConfig = {}) => {
  if (!idCard || !departureDate) return false
  const { youngMin = 16, youngMax = 22, oldMin = 55 } = ageConfig
  const birthFormat = getBirthDay(idCard).birthFormat
  const flightFormat = moment(departureDate, 'YYYY-MM-DD')
  const diffYears = flightFormat.diff(birthFormat, 'years')
  return (diffYears >= youngMin && diffYears <= youngMax) || diffYears >= oldMin
}

const getNetFareAmount = (fareDetails = {}) => {
  const item = fareDetails.fares?.find(item => {
    return item.code === 'NetFare'
  })
  return item ? item.amount : ''
}

// 解析 lodash 模板
const compileTemplate = (templateData = '', data = {}) => {
  var compiled = template(templateData)
  return compiled(data)
}

const getAirportName = (airport, code) => {
  const target = find(airport, { code: code })
  if (target) {
    return target.city ? target.city : '--'
  } else {
    return code
  }
}

// 获取机场信息
const getAirportValue = (value, airport, enterKey = 'code', returnKey = 'cityCode') => {
  const item = {}
  item[enterKey] = value
  const target = find(airport, item)
  return target?.[returnKey] ?? value
}

// 航班查询参数解析
const getFlightSearchParams = (params) => {
  const data = cloneDeep(params)
  const { originDestinations, passenger, tripType, isInternational } = data
  let query = {
    type: tripType,
    isInternational: isInternational
  }

  const keys = Object.keys(passenger)
  const values = Object.values(passenger)

  for (let i = 0, len = values.length; i < len; i++) {
    if (values[i] > 0) {
      query[keys[i]] = values[i]
    }
  }

  const originDestination = originDestinations[0]
  originDestination.depDate = originDestination.flightDate
  delete originDestination.flightDate

  query = {
    ...query,
    ...originDestination
  }

  if (tripType === 'ROUNDTRIP' && originDestinations.length > 1) {
    query.arrDate = originDestinations[1].flightDate
  }
  return query
}

/**
 * 转换url，匹配格式转化成目标格式
 * @param obj
 * @param origin
 */
const replaceLinks = (obj, origin = window.location.origin) => {
  // 正则表达式将匹配所有小程序匹配的格式
  const regexPattern = new RegExp(
    'https?://' + // 匹配协议 'http://' 或 'https://'
    '[^/]+' + // 转义域名中的点并匹配域名
    '(?:/h5/[^/]+)?' + // 非捕获组，可选地匹配 '/h5/{airline}'
    '/modules/content/pages/([^/]+)/([^/?]+)\\?id=([^/]+)' + // 匹配 '/{type}/{page}?id={id}'
    '|' + // OR
    'https?://' + // 匹配协议 'http://' 或 'https://'
    '[^/]+' + // 转义域名中的点并匹配域名
    '(?:/h5/[^/]+)?' + // 非捕获组，可选地匹配 '/h5/{airline}'
    '(?:/m)?' + // 非捕获组，可选地匹配 '/m'
    '/micro/main/([^/?]+)/([^/]+)', // 匹配 '/micro/main/{type}/{id}'
    'i' // 标志表明匹配应该是不区分大小写的
  )

  // 迭代对象的每个属性
  traverseObject(obj, (path, value) => {
    if (typeof value === 'string') {
      return value.replace(regexPattern, (match, p1, p2, p3, p4, p5) => {
        // 检查当前匹配的URL是否与当前页面同源
        console.log('match >>>> ', match)
        if (isSameRootOrigin(match, origin)) {
          const type = p1 || p4 // 获取{type}值
          const id = p3 || p5 // 获取{id}值
          return `/micro/main/${type}/${id}`
        } else {
          return match // 不同源的URL不进行替换
        }
      })
    } else {
      return value
    }
  })
  return obj
}

const getCmsDataFormat = async () => {
  try {
    const cmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) || {}
    const cmsFormatPageData = replaceLinks(cmsData)
    return cmsFormatPageData
  } catch (err) {
    console.log('err >>>> ', err)
  }
}

// 判定是否同源
function isSameRootOrigin (currentDomain, domainToCheck) {
  try {
    const currentRootDomain = new URL(currentDomain)?.hostname.split('.').slice(-2).join('.')
    const domainToCheckRoot = new URL(domainToCheck)?.hostname.split('.').slice(-2).join('.')
    return currentRootDomain === domainToCheckRoot
  } catch (error) {
    console.log('error >>>> ', error)
  }
}

function traverseObject (obj, callback) {
  // 用于递归遍历的辅助函数，它还传递了path参数来追踪当前属性的路径
  function traverse (currentObj, callback, path = '') {
    for (const key in currentObj) {
      if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
        // 生成当前属性的路径
        const currentPath = path ? `${path}.${key}` : key
        // 获取当前属性的值
        const value = currentObj[key]

        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          // 如果是对象，则递归遍历
          traverse(value, callback, currentPath)
        } else {
          // 如果是基本类型或者数组，则执行回调，可能会对值进行修改
          currentObj[key] = callback(currentPath, value)
        }
      }
    }
  }
  traverse(obj, callback)
}

const setAirlineImage = code => {
  if (!code || airlines.includes(code)) {
    return false
  }
  // const imageSrc = imageList?.find(image => image.key?.toLocaleLowerCase() === code.toLocaleLowerCase())?.value
  const imageSrc = MINIO_FRONTEND_STATIC_ROUTE + `/intl-airline-icon/${code}.png`
  return imageSrc
}

// 过滤区分国际国内的CMS数据
const filterRegion = (
  item,
  isInternational = false,
  key = 'region'
) => {
  if (!isEmpty(item)) {
    const region = item[key] || ['ALL']
    const allRegion = (region || []).includes('ALL')
    const ticketRegionType = isInternational ? 'International' : 'Domestic'
    const isCurrentRegion = (region || []).includes(ticketRegionType)

    return allRegion || isCurrentRegion
  } else {
    return false
  }
}

export {
  getBirthDay,
  isOverSixteen,
  isYoungOrOld,
  getNetFareAmount,
  compileTemplate,
  getAirportName,
  getAirportValue,
  getFlightSearchParams,
  getCmsDataFormat,
  setAirlineImage,
  filterRegion
}
